import React, { useContext } from 'react';
import LinkedAccount from './UpdateLinkedAccount';
import { customerDataContext } from '../../contexts/CustomerDataProvider';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import Loading from '../Loading/Loading';
import './updateAccount.scss';

/** @import {Customer, NewAccount} from '../../contexts/CustomerDataProviderTypes' */

const getLinkedAccountData = (/** @type {Customer<NewAccount>} */ customer) => {
    return {
        linkedAccount: {
            accountNumber: customer.accounts[0].linkedAccountNumber,
            sortCode: customer.accounts[0].linkedAccountSortCode,
            accountIds: customer.accounts.map(a => a.id)
        },
        mobileNumber: customer.mobileNumber
    };
};

function UpdateAccount() {
    const data = useContext(customerDataContext);

    if (!data || data.loading || !data.data) {
        return <Loading message="We're loading your account details..." />;
    }

    return (
        <div className="my-account my-account--no-left-padding my-account--my-account">
            <h1 className="my-account__title my-account__title--extra-padding">
                {data.data.customer.accounts.length > 1 ? "My linked account" : "My linked account"}
            </h1>
            <div className="my-account__content my-account__content--small-margin-bottom">
                <div className="my-account__full">
                    <LinkedAccount profile={getLinkedAccountData(data.data.customer)} />
                </div>
            </div>
        </div>
    );
};

export default withFeatureFlags(UpdateAccount);
